import { useState, useEffect, useRef } from 'react'
import Accordion from 'react-bootstrap/Accordion';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Papa from 'papaparse';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';

import { api } from "./pureFunctions";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { de } from 'date-fns/locale/de';
registerLocale('de', de)

const host = import.meta.env.PROD ? "" : "http://localhost:8080"


function Gutschein({ }) {

    const [veranstaltungsdatum, setVeranstaltungsdatum] = useState(new Date());
    const [file, setFile] = useState()
    const [allvisitors, setAllVisitors] = useState([])
    const [visitors, setVisitors] = useState([])
    const [angemeldet, setAngemeldet] = useState(0)
    const [anwesend, setAnwesend] = useState(0)
    const [gutscheinanzahl, setGutscheinanzahl]=useState()
    const [gesamtakquisekontakte, setGesamtAkquiseKontakte]=useState()
    const [searchquery, setSearchQuery] = useState("")
    const [importstate, setImportstate] = useState("loading")
    const [regex, setRegex] = useState()

    function getVisitors(mydate) {

        const newdate = new Date(mydate)
        var year = newdate.getFullYear();
        var month = newdate.getMonth() + 1;
        if (month <= 9)
            month = '0' + month;
        var day = newdate.getDate();
        if (day <= 9)
            day = '0' + day;
        const datestring = day + '.' + month + '.' + year;


        api.post( '/api/getveranstaltungsaddresses', { veranstaltungsdatum: datestring }).then((data) => {
            console.log(data);


            let gesamtpersonenanzahl = 0
            let gesamtgutscheinanzahl=0
            let gesamtakquisekontakte=0
            const visitordata = data.data.map((item, index) => {
                console.log(item.elements.KdNr);
                console.log(item.elements.ind_3084_Feld_adressen95);
                let leadverlauf
                try {
                    leadverlauf = JSON.parse("[" + item.elements.ind_3084_Feld_adressen95.trim().slice(0, -1) + "]")
                } catch (error) {
                    window.alert(`Fehler bei beim Leadverlauf KdNr. ${item.elements.KdNr}. Bitte prüfen, ob die Klammern und Anführungszeichen richtig gesetzt sind. \n\n ${item.elements.ind_3084_Feld_adressen95}`)
                }
                
                const personenanzahl = parseInt(leadverlauf?.find((element) => element.datum === datestring)?.anzahl??0)
                gesamtgutscheinanzahl+=item["elements"].ind_3072_Feld_adressen90?1:0
                gesamtakquisekontakte+=item["elements"].ind_2588_Feld_adressen76?1:0
                gesamtpersonenanzahl += personenanzahl
                return ({ ...item["elements"], personenanzahl: personenanzahl, isChecked: false, index: index, bemerkung: "", telefon: "", wunschzeit: "", prio: "" })
            })
            // console.log(visitordata);
            console.log("Personenanzahl: " + gesamtpersonenanzahl);
            setAngemeldet(gesamtpersonenanzahl)
            setGutscheinanzahl(gesamtgutscheinanzahl)
            setGesamtAkquiseKontakte(gesamtakquisekontakte)

            setVisitors(visitordata)
            setAllVisitors(visitordata)
        })
        setVeranstaltungsdatum(mydate)
    }

    function addVisitor(name) {
        console.log(allvisitors.length);
        const emptyvistor={ KdNr: "00000", Name: name, Vorname: "", personenanzahl: 0, strasse: "", hausnummer: "", plz:"", ort: "",isChecked: false, bemerkung: "", telefon: "", wunschzeit: "", anfragetyp: "", prio: "", email: "", index: allvisitors.length }

        const prevvalue = [...structuredClone(allvisitors), emptyvistor ]
        setVisitors([emptyvistor])
        setAllVisitors(prevvalue)
    }

    useEffect(() => {
        file && Papa.parse(file, {
            complete: function (results) {
                const data = results.data.slice(1, -1)
                const header = results.data[0]

                const visitordata = data.map((datarow, index) => {

                    return ({ KdNr: datarow[0], Anrede: datarow[1], Vorname: datarow[2], Name: datarow[3], isChecked: false, index: index })
                })
                setAllVisitors(visitordata)
                setVisitors(visitordata)

            }
        })
    }, [file])


    useEffect(() => {

const newregex=new RegExp("(.*" + searchquery.toLowerCase() + ")", "g")
        setRegex(newregex)

        setVisitors(allvisitors.filter((element) => !(element.Vorname.toLowerCase() + " " + element.Name.toLowerCase()).search(newregex)))


    }, [searchquery])

    useEffect(() => {
        const onBeforeUnload = (ev) => {
            ev.returnValue = "Anything you wanna put here!";
            return "Anything here as well, doesn't matter!";
        };

        window.addEventListener("beforeunload", onBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", onBeforeUnload);
        };
    }, []);


    function handleSearch(e) {

        e.preventDefault()
        console.log(regex);
        
        console.log(visitors);
        
        if (visitors.length === 1) {
            const prev = structuredClone(allvisitors)
            prev[visitors[0].index].isChecked = !prev[visitors[0].index].isChecked
            setAllVisitors(prev)

            setAnwesend(prevanwesend => prevanwesend + (prev[visitors[0].index].isChecked ? parseInt(prev[visitors[0].index].personenanzahl) : -parseInt(prev[visitors[0].index].personenanzahl)))
            setSearchQuery("")
        }
    }
    function checkVisitor(e, index) {
        e.stopPropagation()

        const prev = structuredClone(allvisitors)
        prev[index].isChecked = !prev[index].isChecked
        setAllVisitors(prev)
        setAnwesend(prevanwesend => prevanwesend + (prev[index].isChecked ? parseInt(prev[index].personenanzahl) : -parseInt(prev[index].personenanzahl)))
        setSearchQuery("")

    }

    function changeVisitorNumber(e, amount, index) {
        e.stopPropagation()
        const prev = structuredClone(allvisitors)
        prev[index].personenanzahl += amount
        setAllVisitors(prev)
        setAnwesend(prevanwesend => prevanwesend + (prev[index].isChecked ? amount : 0))
    }


    function changeVisitor(e, index) {
        e.stopPropagation()

        const prev = structuredClone(allvisitors)
        prev[index][e.target.name] = e.target.value
        setAllVisitors(prev)
    }

    function downloadData(data) {
        console.log(data);
        
        const csv = Papa.unparse(data.map((item=>({ KdNr: item.KdNr, Name: item.Name, Vorname: item.Vorname, Personenanzahl: item.personenanzahl, Strasse: item.strasse, Hausnummer: item.hausnummer, PLZ: item.plz, Ort: item.ort , Anwesend: item.isChecked, Bemerkung: item.bemerkung, email: item.email, Telefon: item.telefon, Wunschzeit: item.wunschzeit, anfragetyp: item.anfragetyp, prio: item.prio}
        ))))

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "Veranstaltung_" + veranstaltungsdatum.toLocaleDateString() + ".csv";
        a.click();
        window.URL.revokeObjectURL(url);
    }


    return (
        <>

            <div className="m-5">

                {(allvisitors.length === 0) && <Form>
                    <Row className="mb-3">
                        {/* <Form.Group as={Col} controlId="formGridbestellanzahl">
                            <Form.Label>CSV-Datei</Form.Label>
                            <Form.Control type='file' onChange={e => setFile(e.target.files[0])} accept=".csv" name='anzahl' value={""} />
                        </Form.Group> */}

                        <Form.Group as={Col} controlId="formGridmaxpreis">
                            <Form.Label>Veranstaltungsdatum</Form.Label>
                            <DatePicker
                                selected={veranstaltungsdatum}
                                /* showIcon */
                                showTimeCaption={false}
                                dateFormat="dd.MM.yyyy"
                                onChange={(date) => getVisitors(date)}
                                locale="de"
                                /* isClearable */
                                className="custom-date-inputfield"
                                calendarClassName="custom-date-calendar"
                                placeholderText=""
                            />
                        </Form.Group>

                    </Row>
                </Form>}
                {(allvisitors.length > 0) && <div>
                    <div style={{ width: "50vw", margin: "auto", textAlign: "center" }}>
                        <h3 onClick={() => setAllVisitors([])}>Suchen:</h3>
                        <Form className="mb-3" onSubmit={handleSearch}>

                            <InputGroup className="mb-3">
                                <Form.Control onChange={e => setSearchQuery(e.target.value)} value={searchquery} />
                                <Button variant="primary" id="button-addon2" onClick={() => addVisitor(searchquery)} >
                                    Neu Hinzufügen
                                </Button>
                            </InputGroup>
                        </Form>
                    </div>
                    <div>
                        <h3>{angemeldet} Besucher angemeldet ({allvisitors.length} Kontakte)</h3>
                        <hr />
                        {/* <h3>{anwesend} Besucher anwesend</h3> */}
                        <h3>{gesamtakquisekontakte-gutscheinanzahl} Kontakte ohne Gutschein</h3>
                        <hr />
                        <h3>{gutscheinanzahl} Gutscheine ausgefüllt</h3>
                        <hr />
                        <h3>{gesamtakquisekontakte} Akquisekontakte</h3>
                    </div>
                    <Accordion>
                        {allvisitors.map((visitor, index) => {
                            return (
                                <>
                                    {(!((visitor.Vorname.toLowerCase() + " " + visitor.Name.toLowerCase()).search(regex))) && <Accordion.Item eventKey={"acc" + index}>
                                        <Accordion.Header><div tabIndex="0" className={visitor.isChecked ? 'anwesend-status' : 'abwesend-status'} onClick={(e) => checkVisitor(e, index)}>
                                            {visitor.isChecked ? "✓" : "×"}</div>
                                            <span className='myaccordion-button' onClick={(e) => changeVisitorNumber(e, 1, index)}>&#65291;</span>{visitor.personenanzahl}
                                            <span className='myaccordion-button' onClick={(e) => changeVisitorNumber(e, -1, index)}>&#65293;</span>
                                            
                                            <span className='' onClick={(e) =>  e.stopPropagation()}>{visitor.Vorname + " " + visitor.Name+" "+visitor.KdNr}</span>
                                            {visitor.ind_3072_Feld_adressen90&&<div tabIndex="0" className='ms-2 anwesend-status'>✓</div>}
                                            <Form.Group className='me-2 ms-4' as={Col} >
                                                <Form.Control placeholder="Bemerkung" name="bemerkung" onClick={e => { e.stopPropagation() }} onChange={(e) => changeVisitor(e, index)} />
                                            </Form.Group>
                                            
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Form>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} >
                                                        <Form.Label>Vorname</Form.Label>
                                                        <Form.Control name="Vorname" value={visitor.Vorname} onChange={(e) => changeVisitor(e, index)} />
                                                    </Form.Group>

                                                    <Form.Group as={Col} >
                                                        <Form.Label>Nachname</Form.Label>
                                                        <Form.Control name="Name" value={visitor.Name} onChange={(e) => changeVisitor(e, index)} />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} >
                                                        <Form.Label>Email</Form.Label>
                                                        <Form.Control type="email" name="email" onChange={(e) => changeVisitor(e, index)} />
                                                    </Form.Group>

                                                    <Form.Group as={Col} >
                                                        <Form.Label>Telefonnummer</Form.Label>
                                                        <Form.Control name="telefon" onChange={(e) => changeVisitor(e, index)} />
                                                    </Form.Group>
                                                </Row>

                                                <Form.Group className="mb-3" >
                                                    <Form.Label>Strasse</Form.Label>
                                                    <Form.Control name="strasse" onChange={(e) => changeVisitor(e, index)} />
                                                </Form.Group>

                                                <Form.Group className="mb-3" >
                                                    <Form.Label>Hausnummer</Form.Label>
                                                    <Form.Control name="hausnummer" onChange={(e) => changeVisitor(e, index)} />
                                                </Form.Group>

                                                <Row className="mb-3">
                                                    <Form.Group as={Col} >
                                                        <Form.Label>PLZ</Form.Label>
                                                        <Form.Control name="plz" onChange={(e) => changeVisitor(e, index)} />
                                                    </Form.Group>


                                                    <Form.Group as={Col} >
                                                        <Form.Label>Ort</Form.Label>
                                                        <Form.Control name="ort" onChange={(e) => changeVisitor(e, index)} />
                                                    </Form.Group>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Form.Group as={Col} >
                                                        <Form.Label>Wann wünschen Sie eine Immobilienbewertung</Form.Label>
                                                        <Form.Select defaultValue="" name="prio" onChange={(e) => changeVisitor(e, index)}>
                                                            <option></option>
                                                            <option>Bewertung kurzfristig gewünscht</option>
                                                            <option>In den nächsten 3-6 Monaten</option>
                                                            <option>Bewertung eilt nicht</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                    <Form.Group as={Col} >
                                                        <Form.Label>Interesse an...</Form.Label>
                                                        <Form.Select defaultValue="" name="anfragetyp" onChange={(e) => changeVisitor(e, index)}>
                                                            <option></option>
                                                            <option>Verkauf</option>
                                                            <option>Bewertung</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                    <Form.Group as={Col} >
                                                        <Form.Label>Wann können wir Sie am besten erreichen?</Form.Label>
                                                        <Form.Select defaultValue="..." name="wunschzeit" onChange={(e) => changeVisitor(e, index)}>
                                                            <option>...</option>
                                                            <option>morgens</option>
                                                            <option>mittags</option>
                                                            <option>abends</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Row>

                                                {/* <Button variant="primary" disabled>
                                                Speichern
                                            </Button> */}
                                            </Form>
                                        </Accordion.Body>
                                    </Accordion.Item>}
                                </>
                            )
                        })}

                    </Accordion>
                    <div className='mt-2'>
                        <Button variant="dark" className='me-2' onClick={() => downloadData(allvisitors)}>
                            Daten runterladen
                        </Button>
                        {/* <Button variant="dark" className='me-2' onClick={() => downloadData(allvisitors)}>
                            Daten in oO speichern
                        </Button> */}
                    </div>
                </div>}
            </div >


        </>
    )
}

export default Gutschein
